// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, TextFieldProps } from '@mui/material';

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
  allowZero?: boolean;
};

export default function RHFTextField({ name, helperText, required, allowZero, ...other }: Props) {
  const { control, trigger } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          required={required}
          onBlur={() => trigger(name)}
          onKeyUp={() => trigger(name)}
          value={
            !allowZero && typeof field.value === 'number' && field.value === 0 ? '' : field.value
          }
          error={!!error}
          helperText={error ? error?.message : helperText}
          {...other}
        />
      )}
    />
  );
}
